import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TTenkoListInfoGetRes,
  TTenkoListGetReq,
  TTenkoInfoGetRes,
  TTenkoPrintTenkoboReq,
  TTenkoDetailInfoGetRes,
  TTenkoDetailUpsertReq,
  TTenkoHeaderGetReq,
  TenkoResultListGetReq,
  TTenkoDetailDeleteReq,
  TChangeTenkobiPutReq,
} from "./TTenko"

/**
 * 点呼記録に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class TenkoService extends ConnectApi {
  /**
   * 点呼一覧取得
   *
   * @param {TTenkoListGetReq} params
   * @memberof tenkoService
   */
  getList = async (params: TTenkoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoListInfoGetRes[]>> =
        await this.getInner(`/truckcontrol/tenko`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼結果一覧取得
   *
   * @param {TenkoResultListGetReq} params
   * @memberof tenkoService
   */
  getResultList = async (params: TenkoResultListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoDetailInfoGetRes[]>> =
        await this.getInner(`/truckcontrol/tenko/resultlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼記録ヘッダ取得
   *
   * @param {TTenkoHeaderGetReq} params
   * @memberof tenkoService
   */
  getHeader = async (params: TTenkoHeaderGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoInfoGetRes>> =
        await this.getInner(`/truckcontrol/tenko/actions/getheader`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼記録ヘッダ前回共通指示事項取得
   *
   * @param {TTenkoHeaderGetReq} params
   * @memberof tenkoService
   */
  getPrevInstruction = async (params: TTenkoHeaderGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoInfoGetRes>> =
        await this.getInner(
          `/truckcontrol/tenko/actions/getinstruction`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼明細取得
   *
   * @param {} params
   * @memberof tenkoService
   */
  getMeisai = async (params: {
    乗務員ID: number
    日付: string
    点呼区分コード: string
    点呼回数: number
  }) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoDetailInfoGetRes>> =
        await this.getInner(
          `/truckcontrol/tenko/${params.乗務員ID}/${params.日付}/${params.点呼区分コード}/${params.点呼回数}`
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 最大点呼回数取得
   *
   * @param {} params
   * @memberof tenkoService
   */
  getMaxTenkoCount = async (params: { 乗務員ID: number; 日付: string }) => {
    try {
      const res: AxiosResponse<TApiResponse<number>> = await this.getInner(
        `/truckcontrol/tenko/count/${params.乗務員ID}/${params.日付}`
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼明細更新
   *
   * @param {TTenkoDetailUpsertReq} data
   * @memberof tenkoService
   */
  putTenko = async (data: TTenkoDetailUpsertReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoDetailInfoGetRes>> =
        await this.putInner(`/truckcontrol/tenko`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 点呼日更新
   *
   * @param {TTenkoDetailUpsertReq} data
   * @memberof tenkoService
   */
  changeTenkobi = async (data: TChangeTenkobiPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TTenkoDetailInfoGetRes>> =
        await this.putInner(`/truckcontrol/tenko/action/change/tenkobi`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TTenkoDetailDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof HinmeiService
   */
  delete = async (
    id: number,
    data: TTenkoDetailDeleteReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `truckcontrol/tenko/detail/delete/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  // ヘッダのみを更新するエリアは画面から削除
  // /**
  //  * ヘッダ登録
  //  *
  //  * @param {TTenkoHeaderUpsertReq} data
  //  * @memberof tenkoService
  //  */
  // post = async (data: TTenkoHeaderUpsertReq) => {
  //   try {
  //     const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //       `/truckcontrol/tenko/header`,
  //       data
  //     )
  //     return res.data
  //   } catch (err) {
  //     throw err
  //   }
  // }

  // /**
  //  * ヘッダ更新
  //  *
  //  * @param {TTenkoHeaderUpsertReq} data
  //  * @memberof KyotenService
  //  */
  // put = async (id: string, data: TTenkoHeaderUpsertReq) => {
  //   try {
  //     const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //       `truckcontrol/tenko/header/${id}`,
  //       data
  //     )
  //     return res.data
  //   } catch (err) {
  //     throw err
  //   }
  // }

  /**
   * 点呼記録簿印刷
   *
   * @param {TTenkoPrintTenkoboReq} params
   * @memberof tenkoService
   */
  printTenkobo = async (
    params: TTenkoPrintTenkoboReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G050203`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
